import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaHtml5, FaCss3Alt, FaJs, FaReact, FaNodeJs, FaDatabase, FaGithub, FaLaravel, FaBootstrap } from 'react-icons/fa';
import { SiVisualstudiocode } from 'react-icons/si';

const icons = [
  { icon: <FaHtml5 className="icon" />, name: "HTML5", color: "#E34F26" },
  { icon: <FaCss3Alt className="icon" />, name: "CSS3", color: "#1572B6" },
  { icon: <FaJs className="icon" />, name: "JavaScript", color: "#F7DF1E" },
  { icon: <FaReact className="icon" />, name: "React.js", color: "#61DAFB" },
  { icon: <FaNodeJs className="icon" />, name: "Node.js", color: "#3C873A" },
  { icon: <FaDatabase className="icon" />, name: "MongoDB", color: "#47A248" },
  { icon: <FaGithub className="icon" />, name: "GitHub", color: "#211F1F" },
  { icon: <FaLaravel className="icon" />, name: "Laravel", color: "#FF2D20" },
  { icon: <FaBootstrap className="icon" />, name: "Bootstrap", color: "#7952B3" },
  { icon: <SiVisualstudiocode className="icon" />, name: "Visual Studio", color: "#5E5E5E" }
];

const firstHalf = icons.slice(0, Math.ceil(icons.length / 2));
const secondHalf = icons.slice(Math.ceil(icons.length / 2));

const TechStack = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const section = document.getElementById('techStackSection');
      if (section) {
        const sectionTop = section.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        setIsVisible(sectionTop < windowHeight);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Call once to check initial visibility

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="container mx-auto shadow-lg rounded-md p-8">
      <section 
        id="techStackSection" 
        className={`py-12 rounded-md ${isVisible ? 'animate-visible' : ''}`} 
        style={{ backgroundColor: '#393E46', color: 'white' }}
      >
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-6">
          <motion.h2 
            className="my-4 font-bold text-3xl sm:text-4xl"
            whileHover={{ scale: 1.05 }}
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
            style={{ color: 'white' }}
          >
            MY <span className="text-blue-500">Tech Stack</span>
          </motion.h2>
          
          <div className="flex flex-wrap justify-center items-center gap-9">
            {firstHalf.map((item, index) => (
              <motion.div 
                key={index}
                className="text-center"
                initial={{ opacity: 0, x: -50 }}
                animate={isVisible ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="relative">
                  <div className="bg-gray-200 rounded-full p-4 shadow-md flex justify-center items-center transition-colors duration-300 hover:bg-gray-300">
                    <div style={{ color: item.color, fontSize: "3rem" }}>{item.icon}</div>
                  </div>
                </div>
                <div className="text-white font-bold capitalize mt-2">{item.name}</div>
              </motion.div>
            ))}
          </div>
          <div className="flex flex-wrap justify-center items-center gap-9 mt-8">
            {secondHalf.map((item, index) => (
              <motion.div 
                key={index}
                className="text-center"
                initial={{ opacity: 0, x: 50 }}
                animate={isVisible ? { opacity: 1, x: 0 } : {}}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <div className="relative">
                  <div className="bg-gray-200 rounded-full p-4 shadow-md flex justify-center items-center transition-colors duration-300 hover:bg-gray-300">
                    <div style={{ color: item.color, fontSize: "3rem" }}>{item.icon}</div>
                  </div>
                </div>
                <div className="text-white font-bold capitalize mt-2">{item.name}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default TechStack;
